/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {useContext} from 'react';
import {AppContext} from "./appContext";
import {requireMaintenanceLogin} from "../../util/maintenanceUtil";
import {Navigate} from 'react-router';
import {AccessKey} from "../../util/interfaces";
import {getDefaultRoute, userHasRight} from "../../util/accessUtil";
import Account from "../../models/accountModel";
import User from "../../models/userModel";

interface Props {
    children: React.ReactElement;
    authenticated?: boolean;
    requireAccessKey?: AccessKey | Array<AccessKey>;
    fallbackRoute?: string;
    authenticator?: (user: User | null, account: Account | null) => boolean;
}

export default function AppRoute(props: Props) {
    const context = useContext(AppContext);
    const {account} = context.accountContext;
    const {user} = context.userContext;
    const {fallbackRoute, children, requireAccessKey, authenticated, authenticator} = props;
    if (requireMaintenanceLogin())
        return <Navigate to='/onderhoud' replace/>;
    if (authenticated && !user?.id.length)
        return <Navigate to='/inloggen' replace/>;
    const defaultRoute = getDefaultRoute(account?.userRights, account?.userRole);
    if (!!authenticator && !authenticator(user, account)) return <Navigate to={fallbackRoute ?? defaultRoute} replace/>;
    if (requireAccessKey) {
        if (!account) {
            return <Navigate to={fallbackRoute ?? defaultRoute} replace/>
        } else if (Array.isArray(requireAccessKey)) {
            if (!requireAccessKey.find((key: AccessKey) => userHasRight(account, key))) {
                return <Navigate to={fallbackRoute ?? defaultRoute} replace/>
            }
        } else if (!userHasRight(account, requireAccessKey)) {
            return <Navigate to={fallbackRoute ?? defaultRoute} replace/>
        }
    }
    return children as React.ReactElement;
}